import { BuilderConfig } from '../../types/Builder';

import BusinessHubImageBlockFull, { ImageBlockFullProps } from './business-hub-image-block-full';

export const BusinessHubImageBlockFullBuilderConfig = {
    name: 'Image Block Full',
    inputs: [
        {
            name: 'image',
            type: 'file',
            defaultValue: '',
        },
        {
            name: 'ratio',
            type: 'number',
        },
        {
            name: 'maxWidth',
            type: 'number',
        },
        {
            name: 'maxHeight',
            type: 'number',
        },
        {
            name: 'minHeight',
            type: 'number',
        },
    ],
};

const builderConfig: BuilderConfig<ImageBlockFullProps> = {
    component: BusinessHubImageBlockFull,
    config: BusinessHubImageBlockFullBuilderConfig,
};

export default builderConfig;
